<script setup>
import { computed } from 'vue';
import { useMessageContext } from '../../provider.js';

import MessageFormatter from 'shared/helpers/MessageFormatter.js';
import { MESSAGE_VARIANTS } from '../../constants';

const props = defineProps({
  content: {
    type: String,
    required: true,
  },
  largeSingleEmoji: {
    type: Boolean,
    default: false,
  },
});

// Aceleres 2026-08-19: a bolha precisa saber se a mensagem acabou por ser um
// emoji sozinho para se desenhar como figurinha (ver Text/Index.vue). Quem
// decide isso e o parse do twemoji, e nao um teste de texto feito aqui — o
// resultado chega por este evento assim que o parse termina.
const emit = defineEmits(['single-emoji']);

const { variant } = useMessageContext();

const formattedContent = computed(() => {
  if (variant.value === MESSAGE_VARIANTS.ACTIVITY) {
    return props.content;
  }

  // Aceleres 2026-08-12: modo restrito ao que o WhatsApp formata. Sem ele,
  // "-----" desaparecia e "- ", "# ", "1. ", "> " perdiam o primeiro caractere.
  return new MessageFormatter(props.content, false, false, true, true)
    .formattedMessage;
});
</script>

<template>
  <!-- As medidas do emoji (sozinho, dois, tres) e o espaco entre eles vivem em
       aceleres-overrides.css, procure por "cw-emoji--single-message": la a
       mesma regra serve a bolha e a previa do modal de informacoes. -->
  <span
    v-dompurify-html="formattedContent"
    v-twemoji="{
      singleMessage: largeSingleEmoji,
      onSingleEmoji: value => emit('single-emoji', value),
    }"
    class="prose prose-bubble"
  />
</template>
